import React from 'react'
import { Toggle, Divider, ToggleGroup } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { useDarkModeContext } from '../../providers/darkModeProvider/DarkModeProvider'

const DARK_MODE_FEATURE_FLAG = 'rip_sharedImageViewer_darkMode'

export default function DarkModeControl() {
  const { isOn: isDarkModeFeatureEnabled } = useFeatureFlag(DARK_MODE_FEATURE_FLAG)
  const [t] = useTranslation()
  const { isDarkModeOn, setIsDarkModeOn, loading } = useDarkModeContext()

  if (!isDarkModeFeatureEnabled) return null

  const handleChange = ({ target: { checked } }) => {
    setIsDarkModeOn(checked)

    // Track the toggle event for analytics, including the new value of the toggle (checked or unchecked)
    trackEvent({
      event_name: 'click_action',
      link_name: 'dark_mode_toggle',
      link_value: checked,
    })
  }

  return (
    <>
      <Divider label={t('film-viewer.toggle-dark-mode.label', 'Toggle Dark Mode')} marginY="xxs" />
      <ToggleGroup>
        <Toggle
          disabled={loading}
          label={t('shared-image-viewer.darkMode', 'Dark Mode')}
          allowLabelWrapping
          name="darkMode"
          checked={loading ? false : isDarkModeOn}
          onChange={handleChange}
          data-testid="dark-mode-toggle"
        />
      </ToggleGroup>
    </>
  )
}
